const bronze = {
  bronze1: "hsl(17, 10.0%, 8.8%)",
  bronze2: "hsl(15, 14.8%, 10.6%)",
  bronze3: "hsl(15, 16.3%, 14.3%)",
  bronze4: "hsl(16, 17.1%, 17.2%)",
  bronze5: "hsl(16, 17.6%, 19.6%)",
  bronze6: "hsl(16, 18.1%, 22.9%)",
  bronze7: "hsl(17, 18.8%, 28.8%)",
  bronze8: "hsl(17, 19.6%, 38.0%)",
  bronze9: "hsl(17, 20.0%, 54.0%)",
  bronze10: "hsl(18, 24.0%, 59.0%)",
  bronze11: "hsl(18, 35.0%, 68.5%)",
  bronze12: "hsl(18, 57.0%, 94.1%)"
};
export { bronze };
//# sourceMappingURL=bronze.mjs.map
